var render = function render(){var _vm=this,_c=_vm._self._c;return _c('RouterLink',{staticClass:"px-3 py-2 text-decoration-none w-full hover:rounded hover:bg-gray-100 text-left relative flex",attrs:{"to":_vm.link.to,"active-class":"activeLink"}},[_c('p',{class:[`${_vm.link.class} text-wcDarkGray text-xs`, {activeText: _vm.isActive()}]},[_vm._v(_vm._s(_vm.link.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }